<template>
    <div id="footer">
        <ul>
            <li class="contact">
                <b>商河县智慧农业大数据平台</b>
                <div>
                    <p><i class="icon-service"></i><span>联系地址：济南市商河县商中路208号</span></p>
                    <p><i class="icon-address"></i><span>联系电话：0531-84880196</span><i class="icon-zipcode"></i><span>邮政编码：251600</span></p>
                </div>
            </li>
            <li class="line"></li>
            <li class="qr-code">
                <div class="m-l-20">
                    <img src="http://shanghe.agdata.cn/files/FrontPage/BottomInfo/qrcode_1705_1.png" alt="" width="90px">
                    <p>商河乡村振兴</p>
                </div>
                <div>
                    <img class="qrcode_1_h5_app_download" src="http://shxczx.innomesh.cn:12005/img/pbc.09411a8c.png" alt="" width="90px">
                    <p>数字三农</p>
                </div>

            </li>
        </ul>
        <div class="clear"></div>
        <div class="beian">Copyright © 2021 - {{new Date().getFullYear()}} 济南市商河县农业农村局 创意银航技术有限公司 技术支持</div>
    </div>
</template>

<script>
const pbc = require('@/assets/img/pbc.png')
export default {
    name: "Footer",
    setup() {
        return {
            pbc
        }
    }
}
</script>

<style scoped>
i {display: inline-block}
ul, ol {
    list-style: none;
}
    #footer { background-color: #232230; min-width: 1200px; }

    #footer ul { width: 1200px; height: 132px; margin: 0 auto; padding: 34px 0; color: #747381; font-size: 14px; }

    #footer ul li { float: left; width: 238px; height: 100%; }

    #footer ul li.line { width: 1px; background-image: url("http://shanghe.agdata.cn/img/common/bg-new.png"); background-repeat: no-repeat; background-position: -41px -120px; margin-right: 165px; }

    #footer ul li a { display: block; width: 238px; color: #999; line-height: 26px; text-align: center; }

    #footer ul li a:hover { color: #fff; }

    #footer ul li p { height: 28px; line-height: 28px; }

    #footer ul li p:hover { color: #fff; }

    #footer ul li.contact { width: 560px; margin-left: 63px; padding: 18px 0 0 80px; }

    #footer ul li.contact b { display: block; font-size: 16px; color: #ffffff; margin-bottom: 28px; }

    #footer ul li.contact i { width: 23px; height: 18px; background: url("http://shanghe.agdata.cn/img/common/bg-new.png") no-repeat; vertical-align: middle; }

    #footer ul li.contact i.icon-phone { background-position: -100px -57px; }

    #footer ul li.contact i.icon-email { background-position: -146px -57px; }

    #footer ul li.contact i.icon-qq { background-position: -193px -57px; }

    #footer ul li.contact i.icon-address { background-position: -96px -97px; }

    #footer ul li.contact i.icon-service { background-position: -189px -96px; }

    #footer ul li.contact i.icon-zipcode { background-position: -144px -97px; }

    #footer ul li.contact p { margin-top: 1px; }

    #footer ul li.contact span { margin-right: 20px; }

    #footer ul li.qr-code { width: 200px; height: 157px; padding-top: 20px; text-align: center; }

    #footer ul li.qr-code div { float: left; width: 90px; height: 34px; }

    #footer ul li.qr-code div.m-l-20 { margin-right: 20px; }

    #footer .beian { text-align: center; color: #56555e; line-height: 40px; background-color: #1c1c27; }
    .clear {
        clear: both;
        display: block;
    }
</style>
